<template>
  <div>
    <div>
      <div class="flex items-center justify-center p-5 text-center bg-white rounded">
        <div class="text-2xl font-bold">{{ $t('task.approve_list') }}</div>
      </div>
      <div class="grid grid-cols-5 gap-2 py-3">
        <div>
          <!-- button rounded  -->
          <router-link class="router-class" to="area-interest">
            {{ $t('area.booking_area') }}
            <span
              v-if="countApproveTaskAreaInterest && isPermission('enableApproveAreaInterest')"
              class="rounded-full px-2 bg-red-500 text-white"
            >
              {{ countApproveTaskAreaInterest || 0 }}
            </span>
          </router-link>
        </div>
        <div>
          <router-link class="router-class" to="setting-billing">
            {{ $t('setting.invoice_setting') }}
            <span
              v-if="countApproveTaskSettingBilling && isPermission('enableApproveSettingBilling')"
              class="rounded-full px-2 bg-red-500 text-white"
            >
              {{ countApproveTaskSettingBilling || 0 }}
            </span>
          </router-link>
        </div>
        <div>
          <router-link class="router-class" to="setting-areaacc">
            {{ $t('setting.area_accounting_product_setting') }}
            <span
              v-if="countApproveTaskSettingAreaAcc && isPermission('enableApproveSettingAreaAccounting')"
              class="rounded-full px-2 bg-red-500 text-white"
            >
              {{ countApproveTaskSettingAreaAcc || 0 }}
            </span>
          </router-link>
        </div>
        <div>
          <router-link class="router-class" to="appeal">
            {{ $t('appeal.notification_and_appeal') }}
            <span
              v-if="countApproveTaskAppeal && isPermission('enableViewAppeal')"
              class="rounded-full px-2 bg-red-500 text-white"
            >
              {{ countApproveTaskAppeal || 0 }}
            </span>
          </router-link>
        </div>
        <div>  
          <router-link class="router-class" to="contract-check-out">
            {{ $t('customer.seller_checkout') }}
            <span
              v-if="countApproveTaskContractCheckOut && isPermission('enableApproveCheckout')"
              class="rounded-full px-2 bg-red-500 text-white"
            >
              {{ countApproveTaskContractCheckOut || 0 }}
            </span>
          </router-link>
        </div>
      </div>
    </div>
    <div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    marketId: String,
  },
  computed: {
    ...mapGetters({
      approveTasks: "approveTask/approveTasks",
      countApproveTaskAreaInterest: "approveTask/countApproveTaskAreaInterest",
      countApproveTaskAppeal: "approveTask/countApproveTaskAppeal",
      countApproveTaskSettingBilling: "approveTask/countApproveTaskSettingBilling",
      countApproveTaskSettingAreaAcc: "approveTask/countApproveTaskSettingAreaAcc",
      countApproveTaskContractCheckOut: "approveTask/countApproveTaskContractCheckOut",
    }),
    admin() {
      return this.$store.getters["admin/getByMarketId"](this.marketId);
    },
    employee() {
      return this.$store.getters["employee/getByMarketId"](this.marketId);
    },
  },
  data() {
    return {};
  },
  methods: {
    isPermission(rule){
      if(this.admin || (this.employee && this.employee[rule])){
        return true
      }
    }
  }
};
</script>

<style scoped>
.router-link-exact-active {
  @apply text-screamin-green-700 !important;
}
.router-class {
  @apply bg-white block w-full p-3 text-center text-black transition-all  rounded hover:text-screamin-green-700 hover:scale-110;
}
</style>